module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/BattlesButton/images/light.094030d1.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/BattlesButton/images/light.png
// module id = 3062
// module chunks = 11